import { addDays } from "date-fns";
import { filter, map, take } from "rxjs";

import { useShoppingCar } from "../../../common/components/useShoppingCart";
import { useQueryParams$ } from "../../../common/hooks/useQueryParams$";
import {
  getAttributeList,
  getDateAttribute,
} from "../../../common/searchParams.utils";
import { PaymentPendingSearch } from "./PaymentPendingSearch";
import { PaymentPendingTable } from "./PaymentPendingTable";

export const PaymentPendingResource = () => {
  const params$ = useQueryParams$().pipe(
    filter(() => {
      return (
        window.location.pathname ===
        "/web/importaciones/facturacion/pagos/estadoValidaciones"
      );
    }),
    map((params: any) => {
      const volante_nums = getAttributeList(params.volante_nums);
      const payment_status_list = getAttributeList(params.payment_status_list);
      const payment_type_list = getAttributeList(params.payment_type_list);
      const from_date = getDateAttribute(params.from_date);
      const to_date = getDateAttribute(params.to_date, addDays(new Date(), 5));

      return {
        ...params,
        volante_nums,
        from_date,
        to_date,
        payment_status_list,
        payment_type_list,
      };
    })
  );

  const shoppingCar = useShoppingCar();

  return (
    <>
      <PaymentPendingSearch
        params$={params$.pipe(take(1))}
        clearShoppingCar={() => {
          shoppingCar.items.clear();
        }}
      />
      <PaymentPendingTable params$={params$} shoppingCar={shoppingCar} />
    </>
  );
};
